import React, { MouseEvent, useEffect, useState } from 'react';

import { fc } from 'i18n';
import { Option } from './option';
import { ISelectOption } from 'types/select';
import Input from 'components/molecules/input';
import Button from 'core/react/general/form/Button';

import styles from './styles.module.css';

interface IListProps<T> {
  isLoading?: boolean;
  placeholder?: string;
  selectedId?: T | null;
  options: ISelectOption<T>[] | null;
  selectOption: (option: ISelectOption<T>) => (event: MouseEvent<HTMLDivElement>) => void;
  add: (name: string) => () => void;
}

export const List = <T,>(props: IListProps<T>) => {
  const { isLoading, selectedId, placeholder, options, add, selectOption } = props;

  const [value, setValue] = useState<string>('');

  useEffect(() => {
    !isLoading && setValue('');
  }, [isLoading]);

  return (
    <div className={styles.list}>
      {options?.length ? (
        options.map((option, index) => (
          <Option key={index} isSelected={selectedId === option.value} option={option} selectOption={selectOption} />
        ))
      ) : (
        <div className={styles.noContent}>{fc('no options found')}</div>
      )}
      <div className={styles.footer}>
        <Input placeholder={placeholder} value={value} onChange={(e) => setValue(e.target.value)} />
        <Button onClick={add(value)} className={`${styles.addButton} active`}>
          <span>{fc('add')}</span>
        </Button>
      </div>
    </div>
  );
};
